<!-- 获取车场离线告警日志接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"parkCode":"2KNRNIJC","startTime":"20150115141333","endTime":"20171015141333","pageNum":"1","pageSize":"2"},
            responseCode: 	{
                "data": {
                    "currCount": 1,
        "recordInList": [
            {
                "configNoticeTimes": 100,
                "configReconnectTimeLength": 1,
                "configRemindInterval": 1,
                "configTimeLength": 1,
                "createTime": 1539318156000,
                "handleStatus": 1,
                "handleWay": 1,
                "id": 1744,
                "noticeTimes": 3,
                "parkConnectorId": 33,
                "reconnectTime": 1539318520000
            }
        ],
        "total": 1
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取车场离线告警日志记录信息",
                t_url: this.commonUrls.test+"getParkWarning",
                p_url: this.commonUrls.prod+"getParkWarning",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '时间段起始时间，yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '时间段结束时间，yyyyMMddHHmmss' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'recordInList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkConnectorId', info2: '是', info3: 'Long', info4: '通讯端ID' },
                        { info1: 'configTimeLength', info2: '是', info3: 'Integer', info4: '配置时长单位分钟' },
                        { info1: 'createTime', info2: '是', info3: 'String', info4: '发生时间，yyyyMMddHHmmss' },
                        { info1: 'reconnectTime', info2: '否', info3: 'String', info4: '重连时间，yyyyMMddHHmmss' },
                        { info1: 'handleStatus', info2: '是', info3: 'Byte', info4: '处理状态,0NEW未处理,1PROCESS已处理' },
                        { info1: 'handleTime', info2: '否', info3: 'String', info4: '处理时间，yyyyMMddHHmmss' },
                        { info1: 'handleWay', info2: '是', info3: 'Byte', info4: '处理方式0:MANUAL人工,1AUTO自动' },
                        { info1: 'configNoticeTimes', info2: '是', info3: 'Integer', info4: '当时配置的告警次数' },
                        { info1: 'noticeTimes', info2: '是', info3: 'Integer', info4: '已经告警的次数' },
                        { info1: 'configReconnectTimeLength', info2: '是', info3: 'Integer', info4: '配置的重连后的提醒时长' },
                        { info1: 'configRemindInterval', info2: '是', info3: 'Integer', info4: '提醒间隔时长' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/yard/getParkWarning.vue